/**
 * @generated SignedSource<<bf7fde81f64a1b5ce6784b70cfd1dc5c>>
 * @relayHash dcffe4d3d068e30c47bb837e1721639b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a1c73cb1e3077a24ce0a71dde54f4a0f349366dbf7266593ff10c4488de48afe

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraAutofixJobType = "INTERNAL_REMOVE_FEATURE_FLAG" | "%future added value";
export type JiraAutofixStatus = "COMPLETED" | "FAILED" | "IN_PROGRESS" | "PENDING" | "%future added value";
export type JiraAutofixInput = {
  issueAri: string;
  jobType: JiraAutofixJobType;
};
export type createPrDropdownContentAutofixMutation$variables = {
  cloudId: string;
  input: JiraAutofixInput;
};
export type createPrDropdownContentAutofixMutation$data = {
  readonly jira: {
    readonly devOps: {
      readonly createAutofixJob: {
        readonly errors: ReadonlyArray<{
          readonly extensions: {
            readonly errorType: string | null | undefined;
            readonly statusCode: number | null | undefined;
          } | null | undefined;
          readonly message: string | null | undefined;
        }> | null | undefined;
        readonly job: {
          readonly status: JiraAutofixStatus;
        } | null | undefined;
        readonly success: boolean;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type createPrDropdownContentAutofixMutation = {
  response: createPrDropdownContentAutofixMutation$data;
  variables: createPrDropdownContentAutofixMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "concreteType": "JiraAutofixJob",
  "kind": "LinkedField",
  "name": "job",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "createPrDropdownContentAutofixMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsMutation",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraAutofixCreateJobPayload",
                "kind": "LinkedField",
                "name": "createAutofixJob",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createPrDropdownContentAutofixMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsMutation",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraAutofixCreateJobPayload",
                "kind": "LinkedField",
                "name": "createAutofixJob",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ],
                            "type": "BulkMutationErrorExtension"
                          }
                        ]
                      }
                    ]
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a1c73cb1e3077a24ce0a71dde54f4a0f349366dbf7266593ff10c4488de48afe",
    "metadata": {},
    "name": "createPrDropdownContentAutofixMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "1dab317fd24cc9fd0d8c0de5d3feafc7";

export default node;
